export class HomeInformation {
  public Titulo: string;
  public SubTitulo: string;

  public constructor(){

  }
}
